import { useQuery } from '@tanstack/react-query';
import { AccountsMenu } from '../../../_global/navigation/AccountsMenu';
import { useAuth } from '../../../../components/hooks/useAuth';
import { getMyAccounts } from '../../../../api/UserService';
import { getData } from '../../../../utils/functional/fp';

export function SwitchAccountsMenu({ ...props }) {
  const auth = useAuth();

  const { data: accounts } = useQuery({
    queryKey: ['switch', 'accounts'],
    queryFn: () => getMyAccounts().then(getData),
  });

  return (
    <AccountsMenu
      userColors={{}}
      {...props}
      show={Array.isArray(accounts) && Boolean(accounts.length)}
      accounts={accounts}
      isGhosting={auth.isGhosting}
    />
  );
}
